import polyglotI18nProvider from 'ra-i18n-polyglot';
import customEnglishTranslations from './translations/en';
import englishMessages from 'ra-language-english';

const translations = {
  en: { ...englishMessages, ...customEnglishTranslations },
};

const i18nProvider = polyglotI18nProvider((locale) => translations[locale], 'en', { allowMissing: true });

export default i18nProvider;
